import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopuneonlinecabs() {



  const cardData =
  {
    keyword: ' Mumbai to Pune Online Cab',
    heading: 'Sai Trupti Cabs: Mumbai to Pune Online Cab',
    headingDescription: 'Sai Trupti Cabs now provides seamless Mumbai to Pune online cab booking, so you can arrange your inter-city travel from the comfort of home. Choose your vehicle — Sedan, SUV or Luxury — specify your pickup and drop-off points, and see transparent pricing including tolls and taxes. With background-verified drivers, air-conditioned comfort, and real-time GPS tracking, we make your journey safe, punctual and stress-free. Book your cab with Sai Trupti Cabs online at any hour, enjoy flexible one-way or round-trip options, and travel between Mumbai and Pune with full confidence.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas as the seat of their empire. Once a magnificent seven-storey palace, its grand gates, carved teak balconies, and sprawling courtyards reflect royal elegance and political power. Though much of it was destroyed by fire, the fort’s ruins still whisper tales of valor, intrigue, and sacrifice. The evening light-and-sound show revives the Peshwa era through mesmerizing narration and music. Shaniwar Wada remains the emotional heart of Pune — where history, culture, and pride unite."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace stands as an enduring symbol of India’s freedom movement and Mahatma Gandhi’s legacy. Built in 1892 by Sultan Aga Khan III, the palace later became a place of internment for Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The tranquil gardens, memorials, and museum preserve their memories and personal belongings. Its elegant Italian arches and serene ambiance make it both a historical monument and a place of reflection. Every corner tells a story of sacrifice, resilience, and the unbreakable spirit of India’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the rugged Sahyadri ranges, Sinhagad Fort is a timeless symbol of Maratha courage and pride. The fort gained fame after the legendary battle led by Tanaji Malusare under the command of Chhatrapati Shivaji Maharaj. Trekking up its steep slopes rewards visitors with panoramic views of the valley and Pune city. The fort’s stone walls, ancient gates, and rustic stalls serving pithla-bhakri bring history to life. Sinhagad is not just a fortress — it’s an experience of heritage, adventure, and the indomitable spirit of the Marathas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is a fascinating 8th-century rock-cut shrine carved from basalt, dedicated to Lord Shiva. Located in the heart of Pune, it offers a peaceful escape from city noise and chaos. The circular Nandi mandapa, massive stone pillars, and unfinished sanctum reflect remarkable ancient craftsmanship. Believed to have been excavated during the Rashtrakuta dynasty, the temple’s spiritual aura attracts devotees and historians alike. Amid modern Pune’s growth, Pataleshwar stands as a reminder of its deep and timeless spiritual roots."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering both divine blessings and breathtaking views. The temple complex atop the hill is dedicated to Lord Shiva and Goddess Parvati and was built by the Peshwas in the 18th century. Climbing its 108 stone steps is both a spiritual and meditative experience, rewarded by panoramic views of the city below. The site also houses the Peshwa Museum, which preserves rare artifacts of Maratha glory. At sunrise and sunset, Parvati Hill becomes a golden haven of peace, history, and devotion."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, drawing millions of devotees each year. The temple’s magnificent idol of Lord Ganesha, adorned with gold ornaments and fresh flowers, radiates devotion and positivity. During Ganesh Chaturthi, the entire area transforms into a festival of lights, music, and prayer. The temple also supports charitable causes, embodying the true essence of faith in action. Whether you visit for blessings or simply to soak in its energy, Dagdusheth Temple fills every heart with peace and joy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of Indian art and tradition, housing over 20,000 artifacts collected by the late Dr. Dinkar Kelkar. Its exhibits include intricate musical instruments, ancient sculptures, traditional ornaments, and everyday objects that reveal India’s creative spirit. The museum’s highlight is the replica of a 17th-century Wada — a traditional Maharashtrian mansion. Walking through its corridors feels like stepping back in time. It’s a must-visit for art lovers, history enthusiasts, and anyone seeking to rediscover India’s cultural richness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, just 20 km from Pune, is a popular getaway surrounded by rolling hills and lush greenery. Built across the Mutha River, it serves as the city’s primary water source and a serene picnic spot for families and friends. Visitors enjoy the mesmerizing sunset reflecting off the calm waters while savoring local snacks from nearby stalls. During monsoon, the dam’s scenic charm doubles, making it a photographer’s paradise. It’s the perfect escape for those seeking peace, nature, and a cool breeze away from urban life."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a tranquil oasis that attracts visitors from across the globe. Spread over lush gardens and modern Zen-inspired architecture, it offers various meditation sessions, wellness therapies, and workshops on mindfulness. The serene environment encourages introspection and personal growth. Beyond being a retreat, Osho Resort reflects Pune’s cosmopolitan identity — blending spirituality, modernity, and holistic living. It’s where silence meets luxury, creating an experience that rejuvenates both body and soul."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s famous Korakuen Garden, the Pune Okayama Friendship Garden — also known as Pu La Deshpande Udyan — is an exquisite symbol of Indo-Japanese friendship. Spread across 10 acres, its winding paths, small bridges, ponds, and manicured lawns create a serene landscape ideal for relaxation and photography. The garden’s harmony between Japanese design and Indian flora makes it one of Pune’s most aesthetic green spaces. Families, nature lovers, and photographers visit to unwind amid its calming beauty and artistic symmetry."
  }
],



"services": [
    {
      "name": "Mumbai to Pune Online Cab",
      "description": "Reliable online cab service from Mumbai to Pune offering comfortable rides, professional drivers, and hassle-free booking. Ideal for business travelers, tourists, and daily commuters, with AC and non-AC options, real-time tracking, transparent fares, flexible pickup and drop locations, luggage assistance, well-maintained vehicles, and excellent customer support for a smooth travel experience."
    },
    {
      "name": "Mumbai to Pune Online Taxi",
      "description": "Convenient online taxi service from Mumbai to Pune allowing easy booking through apps or websites. Features include professional drivers, AC/non-AC cars, one-way or round trips, door-to-door service, luggage support, flexible timing, transparent fares, safe and comfortable rides, and real-time tracking ensuring a stress-free journey every time."
    },
    {
      "name": "Mumbai to Pune Online Car Hire",
      "description": "Online car hire service from Mumbai to Pune offering a wide range of vehicles including Sedans, SUVs, and luxury cars. Perfect for business trips, family travel, or group commutes. Enjoy flexible scheduling, professional drivers, AC/non-AC options, luggage handling, real-time tracking, online secure booking, and transparent fares for a safe, convenient, and comfortable journey."
    },
    {
      "name": "Mumbai to Pune Online Innova Cab",
      "description": "Book your Mumbai to Pune Innova cab online for a spacious, comfortable ride suitable for families, groups, or corporate travel. AC service, professional drivers, door-to-door pickup and drop, luggage assistance, flexible scheduling, transparent fares, and real-time tracking make daily or occasional travel smooth, safe, and stress-free."
    },
    {
      "name": "Mumbai to Pune Online Ertiga Cab",
      "description": "Online Ertiga cab service from Mumbai to Pune providing comfortable seating for small groups, AC service, and professional drivers. Ideal for corporate commuters, family trips, or friends traveling together. Features include online booking, flexible pickup and drop points, luggage handling, transparent fares, well-maintained vehicles, and a reliable and convenient travel experience."
    },
    {
      "name": "Mumbai to Pune Online Sedan Cab",
      "description": "Sedan cab service from Mumbai to Pune available for online booking with comfortable, smooth rides for solo travelers, couples, or small families. Professional drivers, AC/non-AC options, flexible pickup and drop, luggage assistance, real-time tracking, transparent fares, and well-maintained vehicles ensure safe, stress-free, and convenient online cab travel."
    },
    {
      "name": "Mumbai to Pune Online One Way Cab",
      "description": "Affordable online one-way cab service from Mumbai to Pune for direct, efficient travel. Features include AC/non-AC options, professional drivers, door-to-door service, luggage support, flexible schedules, transparent fares, and well-maintained vehicles ensuring a reliable and hassle-free journey for daily or occasional commuters."
    },
    {
      "name": "Mumbai to Pune Online Drop Cab",
      "description": "Online drop cab service from Mumbai to Pune providing point-to-point travel with professional drivers, AC cars, and convenient door-to-door service. Perfect for office commuters, students, and travelers seeking safe, reliable, and hassle-free transport. Features include luggage handling, flexible timing, online booking, transparent fares, and well-maintained vehicles for a smooth journey."
    },
    {
      "name": "Mumbai to Pune Online Luxury Cab",
      "description": "Premium online luxury cab service from Mumbai to Pune featuring top-class vehicles, professional chauffeurs, AC service, and elegant interiors. Ideal for VIP travelers, executives, and corporate clients. Features include online booking, luggage assistance, real-time tracking, flexible schedules, transparent fares, well-maintained vehicles, and a comfortable, high-end travel experience."
    },
    {
      "name": "Mumbai to Pune Online Outstation Cab",
      "description": "Online outstation cab service from Mumbai to Pune with long-distance travel comfort. Offers AC/non-AC vehicles, professional drivers, luggage assistance, tolls coverage, flexible schedules, well-maintained cars, secure online booking, transparent fares, and a reliable, safe, and comfortable travel experience for daily, weekly, or occasional outstation trips."
    },
    {
      "name": "Affordable Mumbai to Pune Online Cab",
      "description": "Budget-friendly online cab service from Mumbai to Pune providing cost-effective rides without compromising comfort or safety. Features include AC/non-AC vehicles, professional drivers, flexible pickup and drop, luggage support, secure online booking, transparent fares, real-time tracking, and reliable service for stress-free and convenient travel."
    },
    {
      "name": "Mumbai to Pune Online AC Cab",
      "description": "AC online cab service from Mumbai to Pune providing cool, comfortable, and safe rides for daily commuters, business travelers, and tourists. Features include professional drivers, well-maintained vehicles, flexible pickup and drop locations, luggage assistance, secure online booking, transparent fares, and a reliable, smooth, and enjoyable travel experience."
    },
    {
      "name": "Mumbai to Pune Online Booking Service",
      "description": "Comprehensive online booking service for Mumbai to Pune cabs with multiple vehicle options including Sedans, SUVs, and luxury cars. Features include secure payments, real-time tracking, professional drivers, AC/non-AC options, luggage support, flexible pickup and drop, transparent fares, and reliable service for daily, corporate, and occasional travelers."
    },
    {
      "name": "Mumbai to Pune Online Travel Service",
      "description": "End-to-end online travel service from Mumbai to Pune including cabs, one-way and round trips, drop services, and luxury options. Professional drivers, AC/non-AC vehicles, luggage handling, flexible scheduling, secure online booking, transparent fares, and real-time tracking ensure safe, convenient, and comfortable travel for all types of commuters."
    },
    {
      "name": "Mumbai to Pune Online Cab Near Me",
      "description": "Find Mumbai to Pune online cabs near your location for quick, convenient, and hassle-free booking. Features include AC and non-AC vehicles, professional drivers, door-to-door service, luggage assistance, real-time tracking, transparent fares, well-maintained cars, and reliable service for daily or occasional commuters."
    }
  ],
  "tableData": [
    ["Mumbai to Pune Online Cab", "Mumbai to Pune Online Taxi"],
    ["Mumbai to Pune Online Car Hire", "Mumbai to Pune Online Innova Cab"],
    ["Mumbai to Pune Online Ertiga Cab", "Mumbai to Pune Online Sedan Cab"],
    ["Mumbai to Pune Online One Way Cab", "Mumbai to Pune Online Drop Cab"],
    ["Mumbai to Pune Online Luxury Cab", "Mumbai to Pune Online Outstation Cab"],
    ["Affordable Mumbai to Pune Online Cab", "Mumbai to Pune Online AC Cab"],
    ["Mumbai to Pune Online Booking Service", "Mumbai to Pune Online Travel Service"],
    ["Mumbai to Pune Online Cab Near Me", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Pune Online Cab Booking",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd offers seamless online booking for cab services from Mumbai to Pune—perfect for one‑way trips, airport transfers, or direct inter‑city travel."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Online fares for Mumbai to Pune start from approximately ₹1,746 for one‑way hatchback and around ₹1,799 for sedans, depending on vehicle type and provider. :contentReference[oaicite:turn0search0]{index=1} :contentReference[oaicite:turn0search1]{index=1}"
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs or premium cars to suit your group size, luggage and comfort preferences for the Mumbai → Pune route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and professional drivers are familiar with the Mumbai–Pune expressway and inter‑city travel demands—ensuring a safe, smooth and timely ride."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We allow convenient pickups across Mumbai (city, airport, suburbs) and drop‑offs anywhere in Pune (city, airport, hotel or specific address)."
  },
  {
    "WhyChooseheading": "Clean, Well‑Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized and inspected to provide comfort and reliability for your online‑booked inter‑city trip."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our customer support is available round the clock to assist with online booking, route adjustments or any travel queries."
  },
  {
    "WhyChooseheading": "Hassle‑Free Online Booking Process",
    "WhyChoosedescription": "Book your Mumbai to Pune cab easily via our website or WhatsApp—select date, vehicle type, make payment (or pay at pickup), and receive instant confirmation."
  }
]



























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs Pvt Ltd offer Mumbai to Pune online cab booking?',
    answer: 'Yes, Sai Trupti Cabs Pvt Ltd provides reliable and affordable online cab booking services from Mumbai to Pune, for one‑way, round‑trip, and out‑station travel.',
  },
  {
    question: 'How can I book a Mumbai to Pune cab online with Sai Trupti Cabs?',
    answer: 'You can book your Mumbai to Pune cab through our website, mobile app, or by contacting our 24×7 customer support team. Online booking gives instant confirmation and easy payment.',
  },
  {
    question: 'What types of cabs are available for Mumbai to Pune online booking?',
    answer: 'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and luxury cars to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Mumbai to Pune trips via online booking?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in inter‑city travel via the Mumbai–Pune Expressway, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I book a Mumbai to Pune online cab for airport transfers or business travel?',
    answer: 'Certainly. Our online cab booking services from Mumbai to Pune cater to airport transfers, corporate travel, meetings, leisure trips, and family travel.',
  },
  {
    question: 'Is the Mumbai to Pune online cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 online cab booking services between Mumbai and Pune for your convenience and flexible travel plans.',
  },
  {
    question: 'What are the Mumbai to Pune online cab fares?',
    answer: 'Our online cab fares start from around ₹1,800 for sedans for the Mumbai to Pune route, and higher for SUVs and premium vehicles depending on vehicle type, pickup/drop point, and travel time.',
  },
  {
    question: 'What payment methods are accepted for Mumbai to Pune online cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for secure and smooth online bookings.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Mumbai to Pune online cab rides?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety protocols to ensure a safe and comfortable journey.',
  },
  {
    question: 'Is customer support available during the Mumbai to Pune online cab journey?',
    answer: 'Yes, our 24×7 customer support team is available to assist you before, during, and after your Mumbai to Pune online cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Sharma',
    feedback: 'I booked a cab from Mumbai to Pune online with Sai Trupti Cabs. The booking was easy, the driver was punctual, and the journey was comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Pooja Gupta',
    feedback: 'Sai Trupti Cabs provided excellent service for our Mumbai to Pune trip booked online. Great experience and very professional driver.',
    rating: 5,
  },
];



































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune Online Cab",
  "image": "https://saitrupticabs.com/assets/images/pune-to-shirdi-cab.jpg",
  "description": "Book Mumbai to Pune Online Cab with Sai Trupti Cabs for a safe, comfortable, and convenient journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15864"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/mumbai-to-pune-online-cab"
  }
};






  return (
    <div>
      <Helmet>
  <title>Mumbai to Pune Online Cab | Safe & Comfortable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pune Online Cab with Sai Trupti Cabs for a safe, comfortable, and convenient journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Pune Online Cab, Mumbai to Pune Online Taxi, Mumbai to Pune Online Car Hire, Mumbai to Pune Online Innova Cab, Mumbai to Pune Online Ertiga Cab, Mumbai to Pune Online Sedan Cab, Mumbai to Pune Online One Way Cab, Mumbai to Pune Online Drop Cab, Mumbai to Pune Online Luxury Cab, Mumbai to Pune Online Outstation Cab, Affordable Mumbai to Pune Online Cab, Mumbai to Pune Online AC Cab, Mumbai to Pune Online Booking Service, Mumbai to Pune Online Travel Service, Mumbai to Pune Online Cab Near Me" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/65.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopuneonlinecabs;